/* ============================================
   CART UPSELL BFE - Acelera
   ============================================

   Toevoegen vanuit de upsell-lijst in de winkelwagen.

   Waarom een los bestand en geen <script> in het snippet: de kaarten worden na
   elke cartwijziging opnieuw gerenderd door sections/api-cart-upsell.liquid, en
   het paneel op desktop staat buiten <cart-drawer>. Een luisteraar op de
   container zou bij elke verversing verdwijnen of dubbel gebonden raken.
   Daarom een enkele gedelegeerde luisteraar op document, die blijft werken
   ongeacht hoe vaak de markup vervangt.

   Versie: 1.0.0 - 26-08-2026
   ============================================ */

(function () {
  'use strict';

  var BEZIG = 'cart-upsell-bfe__add-btn--loading';
  var TOEGEVOEGD = 'cart-upsell-bfe__card--added';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    // Werkt voor beide weergaven; de vertrouwde weergave heeft eigen
    // classnames, vandaar een generiek haakje in plaats van een class.
    var card = btn.closest('[data-upsell-card]');
    // Alleen het label vervangen, niet de hele knop: in plus-stand zit het
    // label verstopt en staat het plusje ernaast.
    var label = btn.querySelector('.cart-upsell-bfe__add-label') || btn;
    var origineel = label.textContent;

    if (btn.classList.contains(BEZIG)) return;
    btn.classList.add(BEZIG);
    label.textContent = '...';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Toevoegen mislukt');
        return res.json();
      })
      .then(function () {
        label.textContent = '✓';
        if (card) {
          card.classList.add(TOEGEVOEGD);
          card.classList.add('cart-upsell-legacy-bfe__card--added');
        }
        // Prestige luistert hierop en haalt de lade opnieuw op.
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      })
      .catch(function () {
        label.textContent = origineel;
        btn.classList.remove(BEZIG);
      });
  });
})();

/* ============================================
   Verversen na een cartwijziging
   ============================================

   Prestige haalt bij een wijziging de cart-drawer-sectie op, maar kopieert
   daaruit alleen de innerHTML van <cart-drawer>. Het paneel op desktop staat
   daarbuiten en ververst dus niet mee. Alle upsell-condities zijn
   cart-afhankelijk, dus zonder dit blijft het paneel een product voorstellen
   dat de bezoeker net heeft toegevoegd.

   We halen sections/api-cart-upsell op en vervangen alleen de <li>-kaarten;
   de wrapper met de vormgeving blijft staan.
   ============================================ */

(function () {
  'use strict';

  var bezig = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function ververs() {
    var lijsten = document.querySelectorAll('[data-upsell-list]');
    if (!lijsten.length || bezig) return;
    bezig = true;

    fetch(root() + '?section_id=api-cart-upsell', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Verversen mislukt');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var bron = doc.querySelector('[data-api-content]');
        if (!bron) return;

        document.querySelectorAll('[data-upsell-list]').forEach(function (lijst) {
          lijst.innerHTML = bron.innerHTML;
          // Blijft er niets over, dan verbergt de CSS de wrapper vanzelf via
          // :not(:has(.cart-upsell-bfe__item)) -- niets te doen hier.
        });
      })
      .catch(function () {
        /* Stil falen: de bestaande kaarten blijven staan, dat is beter dan een
           lege lijst. Bij de volgende paginalading klopt het weer. */
      })
      .finally(function () {
        bezig = false;
      });
  }

  document.addEventListener('cart-drawer:refreshed', ververs);
  document.addEventListener('cart:change', ververs);
})();

/* ============================================
   Open-stand van de lade doorgeven aan <html>
   ============================================

   Prestige verhuist <cart-drawer> bij initialisatie naar <body>, terwijl het
   upsell-paneel in zijn eigen sectie achterblijft. Ze zijn dus geen siblings
   en een CSS-selector die op die relatie leunt matcht nooit. Vandaar een
   attribuut op <html>: dat werkt ongeacht waar beide elementen belanden.

   Bewust niet meeliften op Prestige's eigen 'lock'-class op <html>: die wordt
   ook gezet door het menu en de quick-buy, en dan zou het paneel daarbij ook
   tevoorschijn schuiven.
   ============================================ */

(function () {
  'use strict';

  function koppel() {
    var lade = document.getElementById('cart-drawer');
    if (!lade) return false;

    var stand = function () {
      document.documentElement.toggleAttribute('data-cart-drawer-open', lade.hasAttribute('open'));
    };

    new MutationObserver(stand).observe(lade, { attributes: true, attributeFilter: ['open'] });
    stand();

    // Het paneel staat buiten de lade, en Prestige sluit de lade bij elke klik
    // daarbuiten -- ook op de knop 'Toevoegen'. Vandaar dat de winkelwagen
    // dichtklapte in plaats van de variantkiezer te openen.
    //
    // Beide methodes zijn publiek op DialogElement, dus we kunnen ze op deze
    // instantie omleiden voor klikken binnen het paneel. Alles daarbuiten volgt
    // gewoon het oorspronkelijke gedrag.
    if (!lade.__upsellPanelClicksToegestaan) {
      var inPaneel = function (doel) {
        return !!(doel && doel.closest && doel.closest('[data-cart-upsell-slot="panel"]'));
      };

      var origSluiten = lade.hideForOutsideClickTarget.bind(lade);
      lade.hideForOutsideClickTarget = function (doel) {
        return inPaneel(doel) ? false : origSluiten(doel);
      };

      var origToestaan = lade.allowOutsideClickForTarget.bind(lade);
      lade.allowOutsideClickForTarget = function (doel) {
        return inPaneel(doel) ? true : origToestaan(doel);
      };

      lade.__upsellPanelClicksToegestaan = true;
    }

    return true;
  }

  // De lade wordt door het thema verplaatst, dus hij staat er niet altijd al
  // op het moment dat dit script draait.
  if (!koppel()) {
    document.addEventListener('DOMContentLoaded', function () {
      if (!koppel()) {
        var pogingen = 0;
        var timer = setInterval(function () {
          if (koppel() || ++pogingen > 20) clearInterval(timer);
        }, 150);
      }
    });
  }
})();
